import React from 'react';
import './Skeleton.scss';

interface SkeletonProps {
  variant?: 'card' | 'hero' | 'text' | 'circle' | 'image';
  width?: string;
  height?: string;
  className?: string;
}

const Skeleton: React.FC<SkeletonProps> = ({
  variant = 'card',
  width,
  height,
  className = ''
}) => {
  return (
    <div
      className={`skeleton skeleton--${variant} ${className}`}
      style={{
        width: width || undefined,
        height: height || undefined
      }}
    >
      <div className="skeleton__shimmer"></div>
    </div>
  );
};

export default Skeleton;
